export const Title = ({ className, url, headline, subline }) => {
  return `
<div>
    <a class="${className.DETAILS.TITLE.HEADLINE}" href="${url}">${headline}</a>
    <div class="${className.DETAILS.TITLE.SUBLINE}">${subline}</div>
</div>
  `;
};

export default Title;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/components/Details/title.js
 **/